import {
  useGetFhirProviderbyEmailQuery,
  useGetProviderAppointmentRequestsQuery,
} from '../../../../graphql/generated/remote-schema-hasura';
import { useMemo } from 'react';
import {
  ProviderOutput,
  ServiceOfferingsOutput,
  useGetProviderAvailabilityServiceTypesQuery,
} from '../../../../graphql/generated/hasura';
import { IServiceTypes } from '../scheduled-a-appointment/interface';
import { parseServiceType } from '../select-a-provider/ProviderCardProps';
import { useAuth } from '../../../../auth/context/AuthContext';

type AppointmentRequestFilter = {
  limit: number;
  myRequestOffset: number;
};

export const useAppointmentRequests = (filter: AppointmentRequestFilter) => {
  const { data, loading } = useGetProviderAppointmentRequestsQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      limit: +filter.limit,
      offset: +filter.myRequestOffset,
    },
  });

  const total = useMemo(
    () => data?.getProviderAppointmentRequests?.total ?? 0,
    [data],
  );

  const requests = useMemo(
    () => data?.getProviderAppointmentRequests?.requests ?? [],
    [data],
  );

  return { requests, total, loading };
};

export const useGetProviderOfferingsData = () => {
  const { user } = useAuth();
  const { data: providerOutput } = useGetFhirProviderbyEmailQuery({
    skip: !user?.email,
    variables: {
      email: String(user?.email),
    },
  });

  const providerData = useMemo(
    () => providerOutput?.getFHIRProviderbyEmail.providers?.[0] || {},
    [providerOutput],
  ) as ProviderOutput;

  const { data } = useGetProviderAvailabilityServiceTypesQuery({
    skip: !providerData.acuityCalendarId,
    variables: {
      providerCalendarId: providerData.acuityCalendarId as string,
    },
  });

  const serviceTypes = useMemo(
    () => data?.GetProviderAvailabilityServiceTypes?.serviceTypes || [],
    [data],
  );

  const providerTypes: IServiceTypes[] = serviceTypes
    .filter(({ active }) => !!active)
    .map(
      (serviceTypes) =>
        ({
          id: serviceTypes.id,
          price: serviceTypes.price,
          duration: serviceTypes.duration,
          active: serviceTypes.active,
          name: serviceTypes.name,
          description: serviceTypes?.description,
          paddingAfter: serviceTypes.paddingAfter,
        } as IServiceTypes),
    );

  const serviceOfferingsAppointment = (providerData.serviceOfferings || []).map(
    (serviceOffering: ServiceOfferingsOutput) => ({
      price: serviceOffering.price,
      active: serviceOffering.active,
      serviceType: parseServiceType(serviceOffering.serviceType),
    }),
  );

  return { serviceTypes, serviceOfferingsAppointment, providerTypes };
};
